<template>
    <v-dialog v-model="versionDialog" max-width="500">
        <template v-slot:activator="{on}">
            <v-icon left>mdi-information</v-icon>
          <v-hover v-slot:default="{ hover }">
            <span :class="hover ? 'onHoverLink' : 'noHoverLink'" @click="versionButtonClick" v-on="on">{{ $t("aboutWebsite") }}
            </span>
          </v-hover>
        </template>
        <v-card tile>
          <v-card-title class="color5 background--text">
            dr-rashmee.com
          </v-card-title>
          <v-card-text class="black--text">
            <p></p>
            <p>Version: 1.1.2</p>
            <p>Release date: 2020-08-22</p>
            <p>Product of 
              <v-hover v-slot:default="{ hover }">
                <span :class="hover ? 'onHover' : 'noHover'" @click="okkharClicked('versionDialog')">Okkhar</span>
              </v-hover>
            </p>
            <p><strong>Release notes:</strong></p>
            <p>- Reports section added in My Work</p>
            <p>- More materials added in My Work</p>
            <p>- Other debugs</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="versionDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
export default {
    name: "VersionDialog",
    data () {
        return {
            versionDialog: false
        }
    },
    methods: {
      versionButtonClick() {
        this.logEvent("button_click", {
          name: "versionDialog"
        })
      }
    }
}
</script>